import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';
import { ModalController } from '@ionic/angular';
import { StringInfoMessageService } from 'src/app/services/string-info-message/string-info-message.service';
import { DATETIMEFORMART, SearchRequest, SearchRequestNew } from 'src/app/interfaces/interfaces';
import { DatetimeFormatService } from 'src/app/services/datetime-format-service/datetime-format.service';
import { PlacesStore } from '../../../stores/places.store';
import { UserStore } from 'src/app/stores/user.store';
import { UnleashFeatureFlags } from 'src/app/interfaces/interfaces';
@Component({
  selector: 'app-search-popover',
  templateUrl: './searchpopover.component.html',
  styleUrls: ['./searchpopover.component.scss'],
})

export class SearchpopoverComponent  implements OnInit {
  unleashFeatureFlags = UnleashFeatureFlags
  weekdays: { value: string; active: boolean; stringName: string }[] = [
    { value: 'Sun', active: false, stringName: 'weekdayName.Sun' },
    { value: 'Mon', active: false, stringName: 'weekdayName.Mon' },
    { value: 'Tue', active: false, stringName: 'weekdayName.Tue' },
    { value: 'Wed', active: false, stringName: 'weekdayName.Wed' },
    { value: 'Thu', active: false, stringName: 'weekdayName.Thu' },
    { value: 'Fri', active: false, stringName: 'weekdayName.Fri' },
    { value: 'Sat', active: false, stringName: 'weekdayName.Sat' },
  ];
  repeatEveryOptions = [].constructor(30).fill(0).map((_, index) => index + 1)
  @Input() initalSearchRequest:SearchRequest
  @Input() modalTitle: string;
  visibileDateTimeSelect = {
    startTimePicker : false,
    startDatePicker:false,
    endTimePicker : false,
    endDatePicker:false,
    recurrenceEndDate:false
  }
  locale = this.dateTimeFormatService.selectedDateTimeFormat;
  showError = false
  errorMessage = ""
  scheduleMeetingInputValue  = { 
    localStartTimeValue: moment().add(5 - (moment().minute() % 5), 'minutes').format(DATETIMEFORMART),
    localEndTimeValue: moment().add(5 - (moment().minute() % 5) + 30, 'minutes').format(DATETIMEFORMART),
    isAllDay:false,
    isWorkingHours:false,
    recurrenceEndDate: moment().format(DATETIMEFORMART),
    recurrenceType:'none',
    repeatEvery:1,
    selectedWeekDays:[],
  }
  scheduleMeetingInputValueCopyForReset = {...this.scheduleMeetingInputValue} 
  constructor(private dateTimeFormatService : DatetimeFormatService,private modalController: ModalController,public stringInfoMessageService:StringInfoMessageService,private placesStore:PlacesStore,private userStore:UserStore) { }

  seriesMessage: string = '';

  updateSeriesMessage() {
    this.seriesMessage = this.stringInfoMessageService.seriesEventInformationMessageForSeriesSearchRequest(this.scheduleMeetingInputValue, false);
  }

  ngOnInit() {
    if(this.initalSearchRequest != null)  {
      this.mapExistingSearchRequestValues()
    }
    // this.dateTimeFormatService.selectedDateTimeFormat$.subscribe((format) => {
    //   this.locale = format;
    // });
    this.updateSeriesMessage();
  }

  toggleDateTimePicker(type : 'startDatePicker' | 'startTimePicker' | 'endDatePicker' | 'endTimePicker' | 'recurrenceEndDate') {
    Object.keys(this.visibileDateTimeSelect).forEach(key => {
      if(key == type) return
      this.visibileDateTimeSelect[key] = false
    })
    this.visibileDateTimeSelect[type] = !this.visibileDateTimeSelect[type]
  }
  
  mapExistingSearchRequestValues() {
    if(this.placesStore.searchRequestType() == 'series') {
      this.scheduleMeetingInputValue.recurrenceType = this.placesStore.searchRequest().recurrencePattern.accuranceType
      this.scheduleMeetingInputValue.repeatEvery = this.placesStore.searchRequest().recurrencePattern.interval
      this.scheduleMeetingInputValue.recurrenceEndDate = moment(this.placesStore.searchRequest().recurrencePattern.endDate).format(DATETIMEFORMART)
      this.scheduleMeetingInputValue.selectedWeekDays = this.placesStore.searchRequest().recurrencePattern.accuranceDays

      this.scheduleMeetingInputValue.selectedWeekDays.forEach(weekdayAsIndex => {
        this.weekdays[weekdayAsIndex].active = true
      })
    }
    this.scheduleMeetingInputValue.localStartTimeValue = moment(this.placesStore.searchRequest().startTime).format(DATETIMEFORMART)
    this.scheduleMeetingInputValue.localEndTimeValue = moment(this.placesStore.searchRequest().endTime).format(DATETIMEFORMART)
    this.scheduleMeetingInputValue.isAllDay = this.placesStore.searchRequest().isAllDay ?? false;
  }

  handleTimeChange(event,type : 'localStartTimeValue' | 'localEndTimeValue' | 'recurrenceEndDate') {
    this.scheduleMeetingInputValue[type] = event.detail.value
    this.updateSeriesMessage();
    if(type == 'localStartTimeValue') {
      let startTime = moment(this.scheduleMeetingInputValue.localStartTimeValue);
      this.weekdays.forEach((day) => {
        if (moment(startTime).format('ddd') == day.value) {
          day.active = true; 
        } else {
          day.active = false
        }
      });
      if (this.scheduleMeetingInputValue.isAllDay) {
        this.scheduleMeetingInputValue.localStartTimeValue = moment(
          this.scheduleMeetingInputValue.localStartTimeValue
        )
          .startOf('day')
          .format(DATETIMEFORMART);
        this.scheduleMeetingInputValue.localEndTimeValue = moment(
          this.scheduleMeetingInputValue.localStartTimeValue
        )
          .add(1, 'day')
          .startOf('day')
          .format(DATETIMEFORMART);
      } else if (this.scheduleMeetingInputValue.isWorkingHours) {
        this.scheduleMeetingInputValue.localEndTimeValue = moment(this.scheduleMeetingInputValue.localStartTimeValue).set('hours', this.userStore.user().workingHours.endTime.hour).set('minutes', this.userStore.user().workingHours.endTime.minute).format(DATETIMEFORMART)
      }
      else {
        this.scheduleMeetingInputValue.localEndTimeValue = startTime.add(1, 'hour').format(DATETIMEFORMART);
      }
      if (this.scheduleMeetingInputValue.recurrenceType != "none") {
        this.updateValuesBasedOnRecurrenceType(this.scheduleMeetingInputValue.recurrenceType)
      }
    }
  }

  handleAllDayToggle(event) {
    this.scheduleMeetingInputValue.isAllDay = event.detail.checked
    this.updateSeriesMessage();

    if(this.scheduleMeetingInputValue.isAllDay == true) {
      // Disable working hours when all-day is selected
      this.scheduleMeetingInputValue.isWorkingHours = false;
      this.scheduleMeetingInputValue.localStartTimeValue = moment(this.scheduleMeetingInputValue.localStartTimeValue).startOf('day').format(DATETIMEFORMART)
      this.scheduleMeetingInputValue.localEndTimeValue = moment(this.scheduleMeetingInputValue.localStartTimeValue).add(1, 'day').startOf('day').format(DATETIMEFORMART)
    } else {
      let roundedStartTime = moment();
        const remainder = 5 - (roundedStartTime.minute() % 5);
        roundedStartTime = roundedStartTime.add(remainder, 'minutes');
        this.scheduleMeetingInputValue.localStartTimeValue =
          roundedStartTime.format(DATETIMEFORMART);
        this.scheduleMeetingInputValue.localEndTimeValue = moment(
          this.scheduleMeetingInputValue.localStartTimeValue
        )
          .add(60, 'minutes')
          .format(DATETIMEFORMART);
    }
  }

  handleWorkingHoursToggle(event) {
    this.scheduleMeetingInputValue.isWorkingHours = event.detail.checked
    this.updateSeriesMessage();

    if(this.scheduleMeetingInputValue.isWorkingHours == true) {
      // Disable all-day when working hours is selected
      this.scheduleMeetingInputValue.isAllDay = false;
      // Set working hours: 9 AM to 5 PM
      const workingHours = this.userStore.user().workingHours
     this.scheduleMeetingInputValue.localStartTimeValue = moment().set('hours', workingHours.startTime.hour).set('minutes', workingHours.startTime.minute).format(DATETIMEFORMART)
     this.scheduleMeetingInputValue.localEndTimeValue = moment().set('hours', workingHours.endTime.hour).set('minutes', workingHours.endTime.minute).format(DATETIMEFORMART)
    } else {
      // Reset to default behavior (current time + 30 minutes)
      this.scheduleMeetingInputValue.localStartTimeValue = moment().add(5 - (moment().minute() % 5), 'minutes').format(DATETIMEFORMART)
      this.scheduleMeetingInputValue.localEndTimeValue = moment(this.scheduleMeetingInputValue.localStartTimeValue).add(30, 'minutes').format(DATETIMEFORMART)
    }
  }

  handleOccurenceType() {
    this.updateValuesBasedOnRecurrenceType(this.scheduleMeetingInputValue.recurrenceType)
    this.updateSeriesMessage();
  }

  toggleWeekday(weekdayName) {
    this.weekdays.forEach((day) => {
      day.value == weekdayName
        && (day.active = !day.active)
    });
    this.updateSeriesMessage();
  }

  
  updateValuesBasedOnRecurrenceType(recurrenceType) {
    switch (recurrenceType) {
      case 'Daily':
        this.scheduleMeetingInputValue.recurrenceEndDate = moment(this.scheduleMeetingInputValue.localStartTimeValue)
          .add(2, 'days')
          .format(DATETIMEFORMART);
        break;
      case 'Weekly':
        this.scheduleMeetingInputValue.recurrenceEndDate = moment(this.scheduleMeetingInputValue.localStartTimeValue)
          .add(8, 'days')
          .format(DATETIMEFORMART);
        this.weekdays.forEach((day) => {
          if (moment(this.scheduleMeetingInputValue.localStartTimeValue).format('ddd') == day.value) {
            day.active = true; 
          } else {
            day.active = false
          }
        });
        break;
      case 'AbsoluteMonthly':
        this.scheduleMeetingInputValue.recurrenceEndDate = moment(this.scheduleMeetingInputValue.localStartTimeValue)
          .add(31, 'days')
          .format(DATETIMEFORMART);
        break;
      default:
        this.scheduleMeetingInputValue.recurrenceEndDate = moment(this.scheduleMeetingInputValue.localStartTimeValue).format(DATETIMEFORMART);
        break;
    }
  }


  mapSearchRequest() {
    let weekdays = []
    this.weekdays.forEach((day)=> {
              if(day.active) {
                const dayIndex = moment().day(day.value).weekday();
                weekdays.push(dayIndex);
              }
            });
    // let searchRequest: SearchRequest =  {
    //       startTime: moment(this.scheduleMeetingInputValue.localStartTimeValue).utc().format(DATETIMEFORMART),
    //       endTime: moment(this.scheduleMeetingInputValue.localEndTimeValue).utc().format(DATETIMEFORMART),
    //       localStartTimeValue: this.scheduleMeetingInputValue.localStartTimeValue,
    //       localEndTimeValue: this.scheduleMeetingInputValue.localEndTimeValue,
    //       startTimeUTC: moment(this.scheduleMeetingInputValue.localStartTimeValue).utc().format(DATETIMEFORMART),
    //       endTimeUTC: moment(this.scheduleMeetingInputValue.localEndTimeValue).utc().format(DATETIMEFORMART),
    //       isAllDay: this.scheduleMeetingInputValue.isAllDay,
    //       repeatEvery: this.scheduleMeetingInputValue.repeatEvery,
    //       recurrenceType: this.scheduleMeetingInputValue.recurrenceType,
    //       recurrenceEndDate: this.scheduleMeetingInputValue.recurrenceEndDate,
    //       selectedWeekDays: weekdays,
    //       dayOfMonthlyMeeting: moment(this.scheduleMeetingInputValue.localStartTimeValue).date(),
    //       recurrenceStartDate: moment(this.scheduleMeetingInputValue.localStartTimeValue).utc().format(DATETIMEFORMART),
    // }
    let searchRequestNew: SearchRequestNew =  {
      startTime: moment(this.scheduleMeetingInputValue.localStartTimeValue).utc().toDate(),
      endTime: moment(this.scheduleMeetingInputValue.localEndTimeValue).utc().toDate(),
      isAllDay: this.scheduleMeetingInputValue.isAllDay,
      recurrencePattern: this.scheduleMeetingInputValue.recurrenceType == 'none' ? null : {
        startTime: moment(this.scheduleMeetingInputValue.localStartTimeValue).utc().toDate(),
        endTime: moment(this.scheduleMeetingInputValue.localEndTimeValue).utc().toDate(),
        startDate: moment(this.scheduleMeetingInputValue.localStartTimeValue).utc().toDate(),
        endDate: moment(this.scheduleMeetingInputValue.recurrenceEndDate).utc().toDate(),
        accuranceDays: weekdays,
        interval: this.scheduleMeetingInputValue.repeatEvery,
        accuranceType: this.scheduleMeetingInputValue.recurrenceType,
        dayOfMonth: moment(this.scheduleMeetingInputValue.localStartTimeValue).date(),
        // month: moment(this.scheduleMeetingInputValue.localStartTimeValue).month(),
        // index: this.scheduleMeetingInputValue.recurrenceType,
      }
    }
    
    return searchRequestNew

  }

  validateInputs(): boolean {
    const { localStartTimeValue, localEndTimeValue, recurrenceEndDate, selectedWeekDays, recurrenceType } = this.scheduleMeetingInputValue;
  
    let startTime = moment(localStartTimeValue);
    let endTime = moment(localEndTimeValue);
    let recurrenceEnd = moment(recurrenceEndDate);
  
    if (startTime.isSameOrAfter(endTime)) {
      this.errorMessage = "Start time must be before end time."
      this.showError = true
      return false;
    }
  
    if ((recurrenceType === 'Weekly') && (this.weekdays.every(day=>!day.active) )) {
      this.errorMessage = "You must select at least one weekday"
      this.showError = true
      return false;
    }

    if (recurrenceType !== 'none' && recurrenceEnd.isBefore(endTime)) {
      this.errorMessage = 'Recurrence end date must be after the meeting time.';
      this.showError = true;
      return false;
    }
    if(recurrenceType !== 'none') {
      const differenceInHours = moment(localEndTimeValue).diff(localStartTimeValue,'hours');
      if (differenceInHours > 24 && differenceInHours > 0) {
        this.errorMessage = 'Can´t book series events for more than 24hrs'
        this.showError = true;
        return false;
      }
    }
           
    this.errorMessage = ''
    this.showError = false
    return true;
  }

  applySearch() {
    const canApply = this.validateInputs()
    if (!canApply) return 
    // this.searchService.applySearch(this.mapSearchRequest())
    this.placesStore.setSearchRequest(this.mapSearchRequest())
    this.dismissModal()
  }

  reset() {
    this.scheduleMeetingInputValue = {...this.scheduleMeetingInputValueCopyForReset}
    Object.keys(this.visibileDateTimeSelect).forEach(key => {
      this.visibileDateTimeSelect[key] = false
    })
    this.updateSeriesMessage();
  }



  async dismissModal() {
    let modal = await this.modalController.getTop()
    modal.dismiss()
  }
}
